export default __webpack_public_path__ + "static/media/ipCasino.fabdbdb7.png";